import { exeRequest } from '../utils/APIUtils'

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    transfertsHistorique: async () => exeRequest(`/admin/transferts/historique`, "GET"),

    sosCreditHistorique: async () => exeRequest(`/admin/sos-credit/historique`, "GET"),

    // nouvelles (avec params)
    transfertsHistoriqueList: async (params) => exeRequest(`/admin/transferts/historique${buildQuery(params)}`, "GET"),
    transfertStats: async (params) => exeRequest(`/admin/transferts/stats${buildQuery(params)}`, "GET"),
    sosCreditHistoriqueList: async (params) => exeRequest(`/admin/sos-credit/historique${buildQuery(params)}`, "GET"),
    // Stats agrégées (rapide, ne transfère pas la liste)
    sosCreditStats: async (params) => exeRequest(`/admin/sos-credit/stats${buildQuery(params)}`, "GET"),

    statsSosCredit: async (params = {}) => {
        const { periode = 'jour', cityCode, from, to } = params;
        return exeRequest(`/admin/stats-sos-credit/${periode}${buildQuery({ cityCode, from, to })}`, "GET");
    },

    statsTransferts: async (params = {}) => {
        const { periode = 'jour', cityCode, from, to } = params;
        return exeRequest(`/admin/stats-transferts/${periode}${buildQuery({ cityCode, from, to })}`, "GET");
    },

    deleteHistoriqueSosCreditById: async (id) => exeRequest(`/admin/sos-credit/historique/${id}`, "DELETE"),
    deleteHistoriqueTransfertById: async (id) => exeRequest(`/admin/transferts/historique/${id}`, "DELETE"),

    rechercherChauffeurPourSos: async (q) => exeRequest(`/admin/sos-credit/recherche-chauffeur?q=${encodeURIComponent(q)}`, "GET"),
    accorderSosCredit: async (data) => exeRequest(`/admin/sos-credit/accorder`, "POST", data),

}